import React from 'react';

import { GetStaticPropsContext, GetStaticPathsResult, GetStaticPropsResult } from 'next';

import { AppLogic } from '../../src/components/AppLogic/AppLogic';
import { GlobalLayout } from '../../src/components/Layouts/GlobalLayout';
import { REVALIDATE } from '../../src/constants/next';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import {
  ProLandingPage,
  IProLandingPageProps,
} from '../../src/views/ProLandingPage/ProLandingPage';

type IParams = {
  couponCode?: string[];
};

export async function getStaticProps({
  params,
}: GetStaticPropsContext<IParams>): Promise<
  GetStaticPropsResult<IPageMetadata & IProLandingPageProps>
> {
  const metadata = {
    _page: 'pro_landing_page',
    _pageTitle: 'Fishbrain Premium - Now Fishbrain Pro',
    canonicalPath: `/pro`,
  };

  if (params?.couponCode?.length) {
    const couponCode = params.couponCode[0];

    return {
      props: {
        ...metadata,
        couponCode,
        _pageSubject: couponCode,
        canonicalPath: `/pro/${couponCode}`,
      },
      revalidate: REVALIDATE.DAILY,
    };
  }

  return { props: metadata, revalidate: REVALIDATE.DAILY };
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<IParams>> {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

ProLandingPage.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout hasStickyBottomBanner hideStickyBannerGetApp>
        {page}
      </GlobalLayout>
    </AppLogic>
  );
};

export default ProLandingPage;
